import React from "react";
import PropTypes from "prop-types";
import { Typography, Box } from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import { useTheme } from "@mui/material/styles";

const IltClassInstructor = ({ instructorName }) => {
  const theme = useTheme();
  return instructorName ? (
    <Box mt={0.25}>
      <Typography variant="caption" color="textSecondary">
        <Box display="flex">
          <Box mr={1} color={theme.palette.action.disabled}>
            <PeopleIcon fontSize="small" />
          </Box>
          {instructorName}
        </Box>
      </Typography>
    </Box>
  ) : null;
};

export default IltClassInstructor;

IltClassInstructor.propTypes = {
  instructorName: PropTypes.string
};
